module.exports = __webpack_public_path__ + "media/enterprise_powerlist/x-22eec9b6.svg";